module.exports = __webpack_public_path__ + "media/02 anticipate.07cd774c.mp3";